
export const getSortField = (field) => {
  if (field === 'originalInstallationType' || field === 'planDate' || field === 'factDate') {
    return `details.${field}`
  }
  return field
}